module.exports = __webpack_public_path__ + "static/media/hero-group-1.9c4efbc0.png";